import { AutoMap } from "@automapper/classes";
import { StatusDto } from "./status.dto";

export class StatusResponseDto {

    @AutoMap()
  public content!: StatusDto[];

}